import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
 FaFacebookF,
 FaInstagram,
 FaLinkedinIn,
 FaPhoneAlt,
 FaEnvelope,
 FaMapMarkerAlt,
} from "react-icons/fa";
import { getCategories } from "../../services/categoryService";
import { stripHtml } from "../../utils/richText";

export default function Footer() {
 const [categories, setCategories] = useState([]);

 useEffect(() => {
  getCategories()
   .then(setCategories)
   .catch(() => setCategories([]));
 }, []);

 return (
  <footer className="bg-dark text-white">
   <div className="container-pad grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
    <div>
     <div className="mb-4 flex items-center gap-3">
      {/* <span className="grid h-11 w-11 place-items-center rounded-xl bg-gradient-to-br from-lime-400 via-primary to-secondary text-xl font-bold text-white">
       M
      </span> */}
      <div className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-xl bg-white p-1">
       <img
        src={"/logo.jpeg"}
        alt="Mozo Group Logo"
        className="h-full w-full object-contain"
       />
      </div>
      <span className="text-xl font-bold">Mozo Group</span>
     </div>
     <p className="leading-7 text-slate-300">
      Premium EV battery products catalogue for cells, BMS, chargers, machines,
      connectors and battery pack accessories.
     </p>
     <div className="mt-5 flex gap-3">
      {[FaFacebookF, FaInstagram, FaLinkedinIn].map((Icon, index) => (
       <a
        key={index}
        href="/"
        className="grid h-10 w-10 place-items-center rounded-xl bg-white/10 transition hover:bg-primary"
        aria-label="Social media"
       >
        <Icon />
       </a>
      ))}
     </div>
    </div>
    <div>
     <h3 className="mb-4 text-lg font-semibold">Quick Links</h3>
     <div className="grid gap-3 text-slate-300">
      {[
       "Home",
       "Categories",
       "Products",
       "About",
       "Contact",
       "Request Quote",
      ].map((item) => (
       <Link
        key={item}
        to={item === "Home" ? "/" : `/${item.toLowerCase().replace(" ", "-")}`}
        className="transition hover:text-primary"
       >
        {item}
       </Link>
      ))}
     </div>
    </div>
    <div>
     <h3 className="mb-4 text-lg font-semibold">Categories</h3>
     <div className="grid grid-cols-2 gap-3 text-slate-300">
      {categories.slice(0, 10).map((category) => (
       <Link
        key={category.id}
        to={`/products?category=${category.id}`}
        className="transition hover:text-primary"
       >
        {stripHtml(category.name)}
       </Link>
      ))}
     </div>
    </div>
    <div>
     <h3 className="mb-4 text-lg font-semibold">Contact</h3>
     <div className="grid gap-4 text-slate-300">
      <p className="flex gap-3">
       <FaMapMarkerAlt className="mt-1 text-primary" /> EV Battery Supply Hub,
       India
      </p>
      <a
       href="mailto:sales@mozogroup.in"
       className="flex gap-3 hover:text-primary"
      >
       <FaEnvelope className="mt-1 text-primary" /> sales@mozogroup.in
      </a>
      <a href="tel:+918700338552" className="flex gap-3 hover:text-primary">
       <FaPhoneAlt className="mt-1 text-primary" /> +91 8700338552
      </a>
     </div>
     <label className="mt-6 block">
      <span className="sr-only">Newsletter email</span>
      <div className="flex overflow-hidden rounded-xl bg-white">
       <input
        className="min-w-0 flex-1 px-4 py-3 text-sm text-dark"
        placeholder="Business email"
       />
       <button className="bg-primary px-4 text-sm font-semibold text-white transition hover:bg-secondary">
        Join
       </button>
      </div>
     </label>
    </div>
   </div>
   <div className="border-t border-white/10 py-5 text-center text-sm text-slate-400">
    Copyright 2026 mozogroup.in All rights reserved.
   </div>
  </footer>
 );
}
